import _ from "lodash"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { SessionKeys } from "../utils/AppUtils"

const useLogin = () => {

    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [loginData, setLoginData] = useState({})
    const [userData, setUserData] = useState({})
    const [subscribedData, setSubscribedData] = useState({})

    const authBroker = useSelector(state => state.auth.authBroker)
    const userDetailRes = useSelector((state) => state.user.userBroker);
    const subscribedInfo = useSelector((state) => state.checkout.subscribedData);

    useEffect(() => {
        if (localStorage.getItem(SessionKeys.API_TOKEN_BROKER) || localStorage.getItem(SessionKeys.API_TOKEN)) {
            setIsLoggedIn(true)
        }
    }, [])

    useEffect(() => {
        if (!_.isEmpty(authBroker) && !_.isEmpty(authBroker.payload?.user)) {
            const userLoginData = authBroker.payload.user;
            setLoginData(userLoginData)
            setSubscribedData(userLoginData.subscription_plan_info)
        }
    }, [authBroker])

    useEffect(() => {
        if (!_.isEmpty(userDetailRes) && !_.isEmpty(userDetailRes?.payload?.payload)) {
            setUserData(userDetailRes?.payload?.payload)
        }
    }, [userDetailRes])

    useEffect(() => {
        if (!_.isEmpty(subscribedInfo)) {
            if (subscribedInfo.status === 'success') {
                const data = subscribedInfo.payload.data;
                if (!_.isEmpty(data)) setSubscribedData(data)
                else setSubscribedData({})
            } else {
                setSubscribedData({})
            }
        }
    }, [subscribedInfo])

    return {
        isLoggedIn: isLoggedIn,
        loginData: loginData,
        userData: userData,
        subscribedData: subscribedData
    }
    
}
export default useLogin